<div class="app-table-container">
  <div class="app-table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort
           [matSortActive]="sortColumnDefault" [matSortDirection]="sortDirectionDefault"
           [matSortDisableClear]="true">

      <ng-container matColumnDef="name" sticky>
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Название</th>
        <td mat-cell *matCellDef="let row">{{row.name}}</td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>С</th>
        <td mat-cell *matCellDef="let row"
            [class.expired]="row.startDate < today">
          {{row.startDate | date:'dd MMMM yyyy'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="finishDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>По</th>
        <td mat-cell *matCellDef="let row"
            [class.expired]="row.finished < today">
          {{row.finishDate.startsWith('9999-12-31') ? 'Бессрочно' : row.finishDate | date:'dd MMMM yyyy'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="link">
        <th mat-header-cell *matHeaderCellDef>Ссылка</th>
        <td mat-cell *matCellDef="let row">
          <a [href]="buildLink(row.urlCode)" target="_blank">{{ buildLink(row.urlCode) }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Тип</th>
        <td mat-cell *matCellDef="let row">{{row.type == 'PUBLIC' ? 'Общая' : 'Личная'}}</td>
      </ng-container>

      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Статус</th>
        <td mat-cell *matCellDef="let row">{{row.active ? 'Активна' : 'Неактивна'}}</td>
      </ng-container>

      <ng-container matColumnDef="trackTelegramUsers">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Telegram</th>
        <td mat-cell *matCellDef="let row">{{row.trackTelegramUsers ? 'Да' : 'Нет'}}</td>
      </ng-container>

      <ng-container matColumnDef="buttons">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          
          <button mat-icon-button 
                  matTooltip="Редактировать"
                  (click)="openTestLinkEditor(row)">
            <mat-icon>edit</mat-icon>
          </button>

          <button mat-icon-button
                  matTooltip="Удалить ссылку"
                  (click)="onTestLinkDelete(row)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>
  </div>
</div>
